import { gtmMiddleware } from './googleTagManager'
import { sagaMiddleware } from './saga'

export const middlewares = [sagaMiddleware, gtmMiddleware]

export * from './saga'
export * from './googleTagManager'
